import { render, staticRenderFns } from "./customLink.vue?vue&type=template&id=fdbb0896&scoped=true&"
import script from "./customLink.vue?vue&type=script&lang=js&"
export * from "./customLink.vue?vue&type=script&lang=js&"
import style0 from "./customLink.vue?vue&type=style&index=0&id=fdbb0896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbb0896",
  null
  
)

export default component.exports